<template>
  <div class="d-flex h-100 padding">
    <div class="d-flex flex h-100 block m-0">

      <div class="aside-deck hide" id="mail-deck">
        <div class="card card-origin alert p-0 m-0 b-a hide">
          <div class="card-header d-flex align-items-center bg-body">
              <div class="flex h-1x mx-1 mail-to">New mail</div>
              <div class="ml-auto no-wrap">
                  <button class="btn btn-sm btn-link btn-icon no-shadow i-con-h-a" data-toggle="tooltip" data-placement="top" title="Send">
                <span>
                    <i class="i-con i-con-arrow-right"><i></i></i>
                </span>
                  </button>
                  <button class="btn btn-sm btn-link btn-icon no-shadow text-muted i-con-h-a" data-toggle-class="card-hide-body" data-target=".card" data-target-closest="true">
                      <i class="i-con i-con-minus"></i>
                  </button>

                  <button class="btn btn-sm btn-link btn-icon no-shadow text-muted i-con-h-a" data-dismiss="alert">
                      <i class="i-con i-con-close"></i>
                  </button>
              </div>
          </div>
          <div class="card-body">
              <form>
                  <div class="mb-2">
                      <input type="text" class="form-control" placeholder="Recipients">
                  </div>
                  <div>
                      <input type="text" class="form-control" placeholder="Subject">
                  </div>
                  <div class="note-editor-inline">
                <textarea class="form-control summernote">
                </textarea>
                  </div>
              </form>
          </div>
        </div>
      </div>
      <div class="d-flex flex" id="content-body">
        <div class="d-flex flex-column flex" id="mail-list" data-plugin="mail">
          <div class="p-3 b-b">
            <div class="toolbar ">
              <button class="btn btn-sm btn-white i-con-h-a" data-toggle="tooltip" title="Trash" id="btn-trash">
                <i class="i-con i-con-trash text-muted"><i></i></i>
              </button>
              <button class="btn btn-sm btn-white i-con-h-a sort " data-sort="item-title" data-toggle="tooltip" title="Sort">
                <i class="i-con i-con-sort text-muted"><i></i></i>
              </button>
              <form class="flex">
                <div class="input-group">
                  <input type="text" class="form-control form-control-sm search" placeholder="Suche" v-debounce:300ms="onSearch">
                  <span class="input-group-append">
                    <button class="btn btn-white no-shadow btn-sm i-con-h-a" type="button">
                      <i class="i-con i-con-search text-muted"></i>
                    </button>
                  </span>
                  <button class="btn btn-sm btn-rounded bg-primary-lt i-con-h-a ml-2" id="btn-new-mail" @click.prevent.stop="$router.push({name: 'CategoryCreate'})">
                    <i class="i-con i-con-plus float-left w-16"></i>
                    {{ $t('message.add') }}
                  </button>
                </div>
              </form>
              <button data-toggle="modal" data-target="#content-aside" data-modal class="btn btn-sm btn-white d-md-none i-con-h-a">
                <i class="i-con i-con-nav text-muted"><i></i></i>
              </button>
            </div>
          </div>

          <div class="scroll-y p-3 h-100">

            <div v-if="!categoriesLoaded" class="h-100 d-flex justify-content-center align-items-center">
              <img alt="Vue logo" src="@/assets/img/loading.gif" width="100px" height="100px">
            </div>

            <b-table striped hover :items="filteredCategories" :fields="list_fields">
              <template slot="books" slot-scope="data">
                <pre>{{ data.item }}</pre>
              </template>

              <template slot="lawyer" slot-scope="data">
                <template v-if="data.item.lawyer && data.item.lawyer.name">{{ data.item.lawyer.name }}</template>
                <template v-else>
                   {{ $t('message.default') }}
                </template>
              </template>

              <template slot="actions" slot-scope="data">
                <div class="action-button-container d-flex">

                  <button class="btn btn-sm btn-white i-con-h-a mr-2"
                          data-toggle="tooltip"
                          v-b-tooltip.hover
                          title="Anzeigen"
                          @click="$router.push('/categories/' + data.item.id + '/view')">
                    <i class="i-con i-con-eye text-muted"><i></i></i>
                  </button>
                  <button
                    class="btn btn-sm btn-white i-con-h-a mr-2" data-toggle="tooltip" 
                    v-b-tooltip.hover
                    @click="$router.push('/categories/' + data.item.id + '/edit')"
                    title="Bearbeiten"><i class="i-con i-con-edit text-muted"><i></i></i></button>
                </div>
              </template>
            </b-table>
          </div>

          <div class="p-3 b-t mt-auto">
            <div class="d-flex align-items-center">
              <div class="flex d-flex flex-row">
                <a href="#" class="btn btn-xs white no-border pager-prev hide">
                    <i class="fa fa-angle-left"></i>
                </a>
                <div class="pagination pagination-xs">
                </div>
                <a href="#" class="btn btn-xs white no-border pager-next hide">
                    <i class="fa fa-angle-right"></i>
                </a>
              </div>
              <div>
                <span class="text-muted">{{ $t('message.total') }}:</span>
                <span id="count"> {{ filteredCategories.length }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CategoryList",

  data() {
    return {
      list_fields: [
        'id',
        {
            key: 'name',
            label: 'Name',
            sortable: true
        },
        {
            key: 'lawyer',
            label: 'Lawyer',
            sortable: true
        },
        'actions'
      ],
      showData: false,
      searchValue: '',
    }
  },

  computed: {
    filteredCategories() {
      if (this.searchValue && this.searchValue.length > 2) {
        const s = this.searchValue.toLowerCase();
        return this.categories.filter(x => {
          if (x.name.toLowerCase().indexOf(s) !== -1) {
            return true;
          }

          if (x.publisher && x.publisher.toLowerCase().indexOf(s) !== -1) {
            return true;
          }

          return false;
        });
      } else {
        return this.categories;
      }
    },
  },

  mounted() {
    // this.showData = false

    // if (!this.categoriesLoaded) {
    //   this.$store.dispatch(CATEGORIES_REQUEST)
    //     .catch(error => {
    //       console.log(error)
    //     })
    //   this.showData = true
    // } else {
    //   setTimeout(() => {
    //     this.showData = true
    //   }, 500)
    // }
  },

  methods: {
    onSearch(value) {
      this.searchValue = value;
    },
  }
}
</script>

<style scoped>

</style>